import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "paginaExtrato",
    staticClass: "pagina-extrato-bancario",
    style: {
      '--altura-util-extrato': _vm.alturaUtilExtrato
    }
  }, [_c('b-sidebar', {
    attrs: {
      "id": "sidebar-transferencia",
      "backdrop-variant": "dark",
      "backdrop": "",
      "right": "",
      "shadow": "",
      "no-header-close": _vm.isSavingTransferencia,
      "no-close-on-backdrop": _vm.isSavingTransferencia,
      "no-close-on-esc": _vm.isSavingTransferencia
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex text-light align-items-center px-3 py-2"
        }, [_c('button', {
          ref: "salvarTranferencia",
          staticClass: "btn btn-primary btn-hover-dark font-weight-bold",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "id": _vm.tipoTransferencia === 'caixa' ? 'btn-salvar-transferencia-caixa' : 'btn-salvar-transferencia-contas',
            "disabled": _vm.isSavingTransferencia,
            "aria-busy": _vm.isSavingTransferencia
          },
          on: {
            "click": _vm.salvarTransferenciaAtual
          }
        }, [_vm.isSavingTransferencia ? _c('b-spinner', {
          staticClass: "mr-1",
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" " + _vm._s(_vm.isSavingTransferencia ? "Transferindo..." : "Realizar transferência") + " ")], 1)])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.mostrarTransferencia,
      callback: function callback($$v) {
        _vm.mostrarTransferencia = $$v;
      },
      expression: "mostrarTransferencia"
    }
  }, [_c('div', {
    staticClass: "px-2 py-2"
  }, [_c('div', {
    staticClass: "p-2",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h4', {
    staticClass: "text-dark"
  }, [_vm._v("Transferência")]), _c('b-form-group', {
    attrs: {
      "label": "Tipo de transferência"
    }
  }, [_c('div', {
    staticClass: "tipo-transferencia",
    attrs: {
      "role": "group",
      "aria-label": "Tipo de transferência"
    }
  }, [_c('b-button', {
    attrs: {
      "type": "button",
      "variant": _vm.tipoTransferencia === 'contas' ? 'primary' : 'outline-primary',
      "disabled": _vm.isSavingTransferencia,
      "data-testid": "tipo-transferencia-contas"
    },
    on: {
      "click": function click($event) {
        return _vm.selecionarTipoTransferencia('contas');
      }
    }
  }, [_vm._v(" Entre contas ")]), _c('b-button', {
    attrs: {
      "type": "button",
      "variant": _vm.tipoTransferencia === 'caixa' ? 'primary' : 'outline-primary',
      "disabled": _vm.isSavingTransferencia,
      "data-testid": "tipo-transferencia-caixa"
    },
    on: {
      "click": function click($event) {
        return _vm.selecionarTipoTransferencia('caixa');
      }
    }
  }, [_vm._v(" Caixa ")])], 1)]), _vm.tipoTransferencia === 'contas' ? _c('p', [_vm._v(" O valor será debitado desta conta e creditado na conta bancária de destino. ")]) : _c('p', [_vm._v("O valor será debitado desta conta e lançado como entrada no Caixa.")]), _c('b-alert', {
    attrs: {
      "show": _vm.tipoTransferencia === 'caixa' && !!_vm.erroTransferenciaCaixa,
      "variant": "danger"
    }
  }, [_vm._v(" " + _vm._s(_vm.erroTransferenciaCaixa) + " ")]), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Conta de origem:",
      "label-for": "transferencia-origem"
    }
  }, [_c('div', {
    staticClass: "form-control h-auto bg-light",
    attrs: {
      "id": "transferencia-origem"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.banco ? _vm.banco.nome : ""))]), _vm.banco ? _c('div', [_vm._v(" Saldo atual: R$ " + _vm._s(_vm.numberToReal(_vm.banco.saldo)) + " ")]) : _vm._e()])])], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Destino:",
      "label-for": "transferencia-destino"
    }
  }, [_vm.tipoTransferencia === 'contas' ? _c('b-form-select', {
    attrs: {
      "id": "transferencia-destino",
      "disabled": _vm.isSavingTransferencia
    },
    model: {
      value: _vm.transferencia.banco,
      callback: function callback($$v) {
        _vm.$set(_vm.transferencia, "banco", $$v);
      },
      expression: "transferencia.banco"
    }
  }, _vm._l(_vm.bancos, function (b) {
    return _c('b-form-select-option', {
      key: b.id_banco + 'bancos',
      attrs: {
        "value": b
      }
    }, [_vm._v(" " + _vm._s(b.nome) + " ")]);
  }), 1) : _c('div', {
    staticClass: "form-control h-auto bg-light font-weight-bold",
    attrs: {
      "id": "transferencia-destino"
    }
  }, [_vm._v(" Caixa ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data da transferência:",
      "label-for": "transferencia-data"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "transferencia-data",
      "type": "date",
      "locale": "pt-br",
      "required": "",
      "min": _vm.dataMinimaTransferenciaAtual,
      "disabled": _vm.isSavingTransferencia
    },
    model: {
      value: _vm.transferencia.data_transferencia,
      callback: function callback($$v) {
        _vm.$set(_vm.transferencia, "data_transferencia", $$v);
      },
      expression: "transferencia.data_transferencia"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Valor R$:",
      "label-for": "transferencia-valor"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "transferencia-valor",
      "disabled": _vm.isSavingTransferencia
    },
    model: {
      value: _vm.transferencia.valor,
      callback: function callback($$v) {
        _vm.$set(_vm.transferencia, "valor", $$v);
      },
      expression: "transferencia.valor"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Observação (opcional):",
      "label-for": "transferencia-observacao"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "transferencia-observacao",
      "rows": "3",
      "disabled": _vm.isSavingTransferencia
    },
    model: {
      value: _vm.transferencia.observacao,
      callback: function callback($$v) {
        _vm.$set(_vm.transferencia, "observacao", $$v);
      },
      expression: "transferencia.observacao"
    }
  })], 1)], 1)], 1)])]), _c('b-sidebar', {
    attrs: {
      "id": "sidebar-movimento-fields",
      "backdrop-variant": "dark",
      "backdrop": "",
      "right": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function fn(_ref) {
        var hide = _ref.hide;
        return [!_vm.lancamento.id_movimento ? _c('div', {
          staticClass: "d-flex text-light align-items-center px-3 py-2"
        }, [_c('button', {
          ref: "salvarMovimento",
          staticClass: "btn btn-primary btn-hover-dark font-weight-bold",
          staticStyle: {
            "width": "100%"
          },
          on: {
            "click": _vm.salvarMovimento
          }
        }, [_vm._v(" Realizar Lançamento ")])]) : _vm._e(), _vm.lancamento.id_movimento ? _c('div', {
          staticClass: "d-flex text-light align-items-center px-3 py-2"
        }, [_c('button', {
          ref: "salvarMovimento",
          staticClass: "btn btn-primary btn-hover-dark font-weight-bold",
          staticStyle: {
            "width": "100%"
          },
          on: {
            "click": _vm.salvarMovimento
          }
        }, [_vm._v(" Atualizar Lançamento ")])]) : _vm._e()];
      }
    }])
  }, [_c('div', {
    staticClass: "px-2 py-2"
  }, [_c('div', {
    staticClass: "p-2",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h4', {
    staticClass: "text-dark"
  }, [_vm._v("Inserir novo movimento:")]), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "descricao",
      "label-for": "descricao",
      "label": "Descrição"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.lancamento.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.lancamento, "descricao", $$v);
      },
      expression: "lancamento.descricao"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_movimento",
      "label-for": "data_movimento",
      "label": "Data Movimento:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "id": "data_movimento",
      "placeholder": " ",
      "locale": "pt-br",
      "min": _vm.dataMinimaMovimento
    },
    model: {
      value: _vm.lancamento.data_movimento,
      callback: function callback($$v) {
        _vm.$set(_vm.lancamento, "data_movimento", $$v);
      },
      expression: "lancamento.data_movimento"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "valor",
      "label-for": "valor",
      "label": "Valor R$:"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.lancamento.valor,
      callback: function callback($$v) {
        _vm.$set(_vm.lancamento, "valor", $$v);
      },
      expression: "lancamento.valor"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo movimento:",
      "label-for": "tipo"
    }
  }, [_c('b-form-select', {
    model: {
      value: _vm.lancamento.tipo,
      callback: function callback($$v) {
        _vm.$set(_vm.lancamento, "tipo", $$v);
      },
      expression: "lancamento.tipo"
    }
  }, _vm._l(_vm.tiposMovimento, function (t) {
    return _c('b-form-select-option', {
      key: t.id + 'tipo',
      attrs: {
        "value": t.id
      }
    }, [_vm._v(" " + _vm._s(t.descricao) + " ")]);
  }), 1)], 1)], 1)], 1)])]), _c('b-card', {
    staticClass: "extrato-bancario",
    attrs: {
      "tag": "article"
    }
  }, [_c('header', {
    staticClass: "extrato-header"
  }, [_c('div', {
    staticClass: "extrato-identificacao"
  }, [_c('button', {
    staticClass: "btn-voltar",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("←")]), _vm._v(" Contas bancárias ")]), _c('h3', {
    staticClass: "extrato-titulo"
  }, [_vm._v(_vm._s(_vm.banco ? _vm.banco.nome : ""))]), _c('div', {
    staticClass: "extrato-subtitulo"
  }, [_vm._v("Extrato bancário")])]), _c('div', {
    staticClass: "saldo-atual-conta"
  }, [_c('span', [_vm._v("Saldo atual da conta")]), _c('strong', [_vm._v("R$ " + _vm._s(_vm.numberToReal(_vm.banco ? _vm.banco.saldo : 0)))])]), _c('div', {
    staticClass: "acoes-conta-bancaria",
    attrs: {
      "data-testid": "acoes-conta-bancaria"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      value: 'Exportar para Excel',
      expression: "'Exportar para Excel'",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    attrs: {
      "variant": "outline-success",
      "aria-label": "Exportar para Excel"
    },
    on: {
      "click": _vm.exportarExtratoXLS
    }
  }, [_c('FileExcel', {
    attrs: {
      "size": 18
    }
  }), _c('span', [_vm._v("Exportar")])], 1), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      value: 'Transferir',
      expression: "'Transferir'",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    attrs: {
      "id": "btn-transferir",
      "variant": "primary",
      "aria-label": "Transferir",
      "disabled": !_vm.banco || _vm.isLoading || _vm.isAtualizandoBanco || _vm.isSavingTransferencia || !!_vm.transferenciaCaixaPendenteAtualizacao
    },
    on: {
      "click": _vm.abrirTransferencia
    }
  }, [_c('SwapHorizontal', {
    attrs: {
      "size": 18
    }
  }), _c('span', [_vm._v("Transferir")])], 1), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.sidebar-movimento-fields",
      modifiers: {
        "sidebar-movimento-fields": true
      }
    }, {
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      value: 'Novo lançamento',
      expression: "'Novo lançamento'",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    attrs: {
      "variant": "primary",
      "aria-label": "Novo lançamento"
    },
    on: {
      "click": function click($event) {
        _vm.lancamento = {};
      }
    }
  }, [_c('Plus', {
    attrs: {
      "size": 18
    }
  }), _c('span', [_vm._v("Nova movimentação")])], 1)], 1)]), _c('b-alert', {
    staticClass: "mt-3",
    attrs: {
      "show": !!_vm.transferenciaCaixaPendenteAtualizacao && !_vm.isLoading && !_vm.isSavingTransferenciaCaixa,
      "variant": "warning"
    }
  }, [_vm._v(" A transferência foi concluída, mas não foi possível atualizar o saldo e o extrato. "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-dark",
      "disabled": _vm.isLoading || _vm.isSavingTransferenciaCaixa
    },
    on: {
      "click": _vm.atualizarExtratoTransferenciaCaixa
    }
  }, [_vm._v(" Atualizar saldo e extrato ")])], 1), _c('b-row', {
    staticClass: "resumo-extrato"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "3"
    }
  }, [_c('div', {
    staticClass: "resumo-card resumo-card--anterior"
  }, [_c('div', {
    staticClass: "resumo-icone"
  }, [_vm._v("$")]), _c('div', [_c('div', {
    staticClass: "resumo-label"
  }, [_vm._v(_vm._s(_vm.rotuloSaldoAnterior))]), _c('div', {
    staticClass: "resumo-valor"
  }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(_vm.resumoExtrato.saldoAnterior)) + " ")])])])]), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "3"
    }
  }, [_c('div', {
    staticClass: "resumo-card resumo-card--entrada"
  }, [_c('div', {
    staticClass: "resumo-icone"
  }, [_vm._v("↑")]), _c('div', [_c('div', {
    staticClass: "resumo-label"
  }, [_vm._v("Entradas no período")]), _c('div', {
    staticClass: "resumo-valor"
  }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(_vm.resumoExtrato.entradas)) + " ")]), _c('div', {
    staticClass: "resumo-detalhe"
  }, [_vm._v(" " + _vm._s(_vm.resumoExtrato.quantidadeEntradas) + " " + _vm._s(_vm.resumoExtrato.quantidadeEntradas === 1 ? "movimentação" : "movimentações") + " ")])])])]), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "3"
    }
  }, [_c('div', {
    staticClass: "resumo-card resumo-card--saida"
  }, [_c('div', {
    staticClass: "resumo-icone"
  }, [_vm._v("↓")]), _c('div', [_c('div', {
    staticClass: "resumo-label"
  }, [_vm._v("Saídas no período")]), _c('div', {
    staticClass: "resumo-valor"
  }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(_vm.resumoExtrato.saidas)) + " ")]), _c('div', {
    staticClass: "resumo-detalhe"
  }, [_vm._v(" " + _vm._s(_vm.resumoExtrato.quantidadeSaidas) + " " + _vm._s(_vm.resumoExtrato.quantidadeSaidas === 1 ? "movimentação" : "movimentações") + " ")])])])]), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "3"
    }
  }, [_c('div', {
    staticClass: "resumo-card",
    class: _vm.classeResultadoPeriodo
  }, [_c('div', {
    staticClass: "resumo-icone"
  }, [_vm._v("=")]), _c('div', [_c('div', {
    staticClass: "resumo-label"
  }, [_vm._v("Resultado do período")]), _c('div', {
    staticClass: "resumo-valor"
  }, [_vm.sinalResultadoPeriodo ? _c('span', [_vm._v(_vm._s(_vm.sinalResultadoPeriodo) + " ")]) : _vm._e(), _vm._v("R$ " + _vm._s(_vm.numberToReal(Math.abs(_vm.resumoExtrato.resultadoPeriodo))) + " ")]), _vm.detalheSaldoFinal ? _c('div', {
    staticClass: "resumo-detalhe"
  }, [_vm._v(" " + _vm._s(_vm.detalheSaldoFinal) + " ")]) : _vm._e()])])])], 1), _c('section', {
    staticClass: "filtros-extrato",
    attrs: {
      "aria-label": "Filtros do extrato"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c('b-row', {
    attrs: {
      "align-v": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Período",
      "label-for": "periodoSelect"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "periodoSelect",
      "options": _vm.periodos
    },
    on: {
      "change": _vm.onPeriodChange
    },
    model: {
      value: _vm.selectedPeriodo,
      callback: function callback($$v) {
        _vm.selectedPeriodo = $$v;
      },
      expression: "selectedPeriodo"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data inicial",
      "label-for": "dataInicial"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "dataInicial",
      "type": "date"
    },
    on: {
      "input": _vm.onDataPersonalizadaChange
    },
    model: {
      value: _vm.data_inicial,
      callback: function callback($$v) {
        _vm.data_inicial = $$v;
      },
      expression: "data_inicial"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data final",
      "label-for": "dataFinal"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "dataFinal",
      "type": "date"
    },
    on: {
      "input": _vm.onDataPersonalizadaChange
    },
    model: {
      value: _vm.data_final,
      callback: function callback($$v) {
        _vm.data_final = $$v;
      },
      expression: "data_final"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo",
      "label-for": "filtroTipo"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "filtroTipo",
      "options": _vm.tiposFiltro
    },
    model: {
      value: _vm.filtroTipo,
      callback: function callback($$v) {
        _vm.filtroTipo = $$v;
      },
      expression: "filtroTipo"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status",
      "label-for": "filtroStatus"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "filtroStatus",
      "options": _vm.statusFiltro
    },
    model: {
      value: _vm.filtroStatus,
      callback: function callback($$v) {
        _vm.filtroStatus = $$v;
      },
      expression: "filtroStatus"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Descrição ou documento",
      "label-for": "buscaMovimento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "buscaMovimento",
      "placeholder": "Buscar..."
    },
    model: {
      value: _vm.buscaMovimentoInput,
      callback: function callback($$v) {
        _vm.buscaMovimentoInput = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "buscaMovimentoInput"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "bloco-listagem-extrato"
  }, [_c('div', {
    staticClass: "lista-extrato-cabecalho"
  }, [_c('h4', [_vm._v(" Movimentações "), _c('span', [_vm._v("(" + _vm._s(_vm.tableMovimentacoes.length) + " registros)")])])]), _vm.isLoading ? _c('div', {
    staticClass: "text-center py-5"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary"
    }
  }), _c('p', [_vm._v("Carregando...")])], 1) : _c('div', {
    staticClass: "bloco-tabela-extrato"
  }, [_vm.tableMovimentacoes.length > 0 ? _c('b-table', {
    staticClass: "tabela-extrato",
    attrs: {
      "hover": "",
      "responsive": "",
      "show-empty": "",
      "fields": _vm.fields,
      "items": _vm.itensTabelaExtrato,
      "tbody-tr-class": _vm.classeLinhaExtrato
    },
    scopedSlots: _vm._u([{
      key: "cell(data_hora)",
      fn: function fn(data) {
        return [!data.item.eh_fechamento_diario ? _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" " + _vm._s(_vm.formatDataHoraMovimento(data.item)) + " ")]) : _c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        })];
      }
    }, {
      key: "cell(tipo_extrato)",
      fn: function fn(data) {
        return [!data.item.eh_fechamento_diario ? _c('span', {
          staticClass: "marcadores-extrato"
        }, [_c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.top",
            modifiers: {
              "hover": true,
              "top": true
            }
          }],
          staticClass: "badge-extrato",
          class: _vm.classeTipo(data.item),
          attrs: {
            "title": "Tipo: ".concat(_vm.tipoMovimento(data.item)),
            "aria-label": "Tipo: ".concat(_vm.tipoMovimento(data.item))
          }
        }, [_vm._v(_vm._s(_vm.siglaTipo(data.item)))]), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.top",
            modifiers: {
              "hover": true,
              "top": true
            }
          }],
          staticClass: "badge-extrato",
          class: _vm.classeStatus(data.item),
          attrs: {
            "title": "Status: ".concat(_vm.statusMovimento(data.item)),
            "aria-label": "Status: ".concat(_vm.statusMovimento(data.item))
          }
        }, [_vm._v(_vm._s(_vm.siglaStatus(data.item)))])]) : _c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        })];
      }
    }, {
      key: "cell(descricao)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "descricao-principal",
          class: {
            'descricao-fechamento': data.item.eh_fechamento_diario
          }
        }, [_vm._v(" " + _vm._s(_vm.descricaoApresentacao(data.item)) + " ")]), _vm.detalheMovimento(data.item) ? _c('div', {
          staticClass: "descricao-detalhe"
        }, [_vm._v(" " + _vm._s(_vm.detalheMovimento(data.item)) + " ")]) : _vm._e()];
      }
    }, {
      key: "cell(origem)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.item.eh_fechamento_diario ? "" : data.item.origem || "—") + " ")];
      }
    }, {
      key: "cell(destino)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.item.eh_fechamento_diario ? "" : data.item.destino || "—") + " ")];
      }
    }, {
      key: "cell(valor_movimento)",
      fn: function fn(data) {
        return [!data.item.eh_fechamento_diario ? _c('span', {
          staticClass: "valor-movimento",
          class: data.item.tipo_movimento === 1 ? 'text-success' : 'text-danger'
        }, [_vm._v(" " + _vm._s(data.item.tipo_movimento === 1 ? "+" : "-") + " R$ " + _vm._s(_vm.numberToReal(data.item.valor_movimento)) + " ")]) : _c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        })];
      }
    }, {
      key: "cell(saldo_apos)",
      fn: function fn(data) {
        return [_c('span', {
          staticClass: "saldo-movimento",
          class: Number(data.item.saldo_apos) < 0 ? 'text-danger font-weight-bold' : ''
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(data.item.saldo_apos)) + " ")])];
      }
    }, {
      key: "cell(acoes)",
      fn: function fn(data) {
        return [!data.item.eh_fechamento_diario && _vm.podeEstornarTransferenciaBancoCaixa(data.item) ? _c('b-button', {
          staticClass: "btn-acao-movimento",
          attrs: {
            "size": "sm",
            "variant": "danger",
            "disabled": _vm.isEstornandoTransferenciaCaixa !== null
          },
          on: {
            "click": function click($event) {
              return _vm.estornarTransferenciaCaixa(data.item);
            }
          }
        }, [_vm.isEstornandoTransferenciaCaixa === (data.item.id_financeiro || data.item.id_movimento) ? _c('b-spinner', {
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" Estornar ")], 1) : !data.item.eh_fechamento_diario && _vm.podeEditarMovimento(data.item) ? _c('b-button', {
          staticClass: "btn-acao-movimento",
          attrs: {
            "size": "sm",
            "variant": "warning"
          },
          on: {
            "click": function click($event) {
              return _vm.editarMovimento(data.item);
            }
          }
        }, [_vm._v(" Editar ")]) : !data.item.eh_fechamento_diario ? _c('span', {
          staticClass: "acao-indisponivel",
          attrs: {
            "aria-label": "Sem ações"
          }
        }, [_vm._v("—")]) : _c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        })];
      }
    }], null, false, 1638122486)
  }) : _c('div', {
    staticClass: "estado-vazio"
  }, [_vm._v(" Nenhuma movimentação encontrada para o período. ")]), _c('footer', {
    staticClass: "rodape-tabela-extrato"
  }, [_c('div', {
    staticClass: "rodape-registros"
  }, [_vm._v(" Mostrando " + _vm._s(_vm.primeiroRegistroPagina) + "–" + _vm._s(_vm.ultimoRegistroPagina) + " de " + _vm._s(_vm.tableMovimentacoes.length) + " movimentações ")]), _c('div', {
    staticClass: "rodape-paginacao"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.tableMovimentacoes.length,
      "per-page": _vm.porPagina,
      "size": "sm",
      "prev-text": "‹",
      "next-text": "›",
      "hide-goto-end-buttons": "",
      "aria-label": "Paginação das movimentações"
    },
    model: {
      value: _vm.paginaAtual,
      callback: function callback($$v) {
        _vm.paginaAtual = $$v;
      },
      expression: "paginaAtual"
    }
  }), _c('b-form-select', {
    staticClass: "seletor-por-pagina",
    attrs: {
      "options": _vm.opcoesPorPagina,
      "size": "sm",
      "aria-label": "Quantidade de movimentações por página"
    },
    model: {
      value: _vm.porPagina,
      callback: function callback($$v) {
        _vm.porPagina = $$v;
      },
      expression: "porPagina"
    }
  })], 1)]), _c('div', {
    staticClass: "text-right font-weight-bold py-3",
    attrs: {
      "data-testid": "saldo-atual-final"
    }
  }, [_vm._v(" Saldo atual da conta: R$ " + _vm._s(_vm.numberToReal(_vm.banco ? _vm.banco.saldo : 0)) + " ")])], 1)])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };